export type PageParams = { page: number; limit: number };

export type ParsePageOptions = {

  defaultLimit: number;

  maxLimit?: number;
};

export const DEFAULT_MAX_LIMIT = 500;

function toPositiveInt(raw: string | null | undefined, fallback: number): number {
  if (raw === null || raw === undefined || raw.trim() === "") {
    return fallback;
  }

  const parsed = Number(raw);

  if (!Number.isFinite(parsed)) {
    return fallback;
  }

  const truncated = Math.trunc(parsed);

  return truncated >= 1 ? truncated : fallback;
}

export function parsePageParams(
  params: { get(name: string): string | null },
  options: ParsePageOptions,
): PageParams {
  const maxLimit = options.maxLimit ?? DEFAULT_MAX_LIMIT;
  const page = toPositiveInt(params.get("page"), 1);
  const limit = Math.min(
    maxLimit,
    toPositiveInt(params.get("limit"), options.defaultLimit),
  );

  return { page, limit };
}
